import React from 'react'

export default function Modal({ isOpen , setIsOpen, data}) {

    return (
        <div className={`fixed top-0 backdrop-blur-sm  bg-gray-200 w-full h-full p-5 z-50 ${isOpen ? 'flex' : 'hidden'}`}>
            <div className="modal__close" onClick={() => setIsOpen(false)}>
                <div className="modal__close__img">
                    {/* <img src="/close.svg" width="24" height="24" alt="close " /> */}
                </div>
            </div>
            <div className="modal__content">

            </div>
        </div>
    )
}
